<template>
    <div class="service ced">
        <navBar></navBar>
        <div class="s-banner"></div>
        <div class="s-title">
            <h2 class="s-txt-h2">定制化企业诊断</h2>
            <p class="s-intro">根据企业经营现状量身定制，一对一课程导入、教学方案提升</p>
        </div>
        <div class="s-content">
            <div class="s-content-item">
                <div class="s-item-img img-1"></div>
                <div class="s-item-info">
                    <img class="s-icon" src="https://restaskimg.civaonline.cn/imagesH5/service/ced-icon1.png" alt="">
                    <div class="s-title-r">
                        <div class="s-title-txt">学生英语能力测试</div>
                        <div class="s-title-intro">提供能力测评摸底当前班级学生英语水平，定位教材切入点</div>
                    </div>
                </div>
            </div>
            <div class="s-content-item">
                <div class="s-item-img img-2"></div>
                <div class="s-item-info">
                    <img class="s-icon" src="https://restaskimg.civaonline.cn/imagesH5/service/ced-icon2.png" alt="">
                    <div class="s-title-r">
                        <div class="s-title-txt">EEC教材方案切换</div>
                        <div class="s-title-intro">专业教研团队根据摸底测评，量身打造教材切入方案，提供开课参考</div>
                    </div>
                </div>
            </div>
            <div class="s-content-item">
                <div class="s-item-img img-3"></div>
                <div class="s-item-info">
                    <img class="s-icon" src="https://restaskimg.civaonline.cn/imagesH5/service/ced-icon3.png" alt="">
                    <div class="s-title-r">
                        <div class="s-title-txt">项目落地计划制定</div>
                        <div class="s-title-intro">综合学校运营、开课计划，定制落地培训计划，项目经理一对一辅助实施</div>
                    </div>
                </div>
            </div>
            <div class="s-content-item">
                <div class="s-item-img img-4"></div>
                <div class="s-item-info">
                    <img class="s-icon" src="https://restaskimg.civaonline.cn/imagesH5/service/ced-icon4.png" alt="">
                    <div class="s-title-r">
                        <div class="s-title-txt">落地材料工具包实施</div>
                        <div class="s-title-intro">新教材家长会开办流程、新教材公开上课资料等海量培训资料，辅助学校平稳过渡</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from '@/components/navBar';
export default {
  components: {
    navBar,
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  },
}
</script>

<style scoped lang="less">
.ced{
    .s-banner{
        background: url("https://restaskimg.civaonline.cn/imagesH5/service/ced-banner.png") no-repeat center center / cover;
    }
    .s-content{
        margin-top: 82px;
        padding: 0 32px;
        .s-content-item{
            padding-bottom: 140px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .s-item-img {
                width: 100%;
                height: 468px;
            }
            .img-1{
                background-image: url("https://restaskimg.civaonline.cn/imagesH5/service/ced-1.png");
            }
            .img-2{
                background-image: url("https://restaskimg.civaonline.cn/imagesH5/service/ced-2.png");
            }
            .img-3{
                background-image: url("https://restaskimg.civaonline.cn/imagesH5/service/ced-3.png");
            }
            .img-4{
                background-image: url("https://restaskimg.civaonline.cn/imagesH5/service/ced-4.png");
            }
            .s-item-info{
                padding: 40px 0 10px;
                display: flex;
                .s-icon{
                    width: 100px;
                    height: 100px;
                    display: block;
                }
                .s-title-r{
                    flex: 1;
                    margin-left: 30px;
                    .s-title-txt{
                        font-family: SyBold;
                        font-size: 32px;
                        color: #293340;
                        line-height: 45px;
                    }
                    .s-title-intro{
                        font-family: SyMedium;
                        font-size: 28px;
                        color: #686B75;
                        margin-top: 20px;
                    }
                }
            }
        }
    }
}
</style>
